<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="基地搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入基地名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加基地</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="baseName"
            label="基地名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="basePhone"
            label="联系电话">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="goodsToBtn(scope.row.id)" type="text" size="small">基地商品</el-button>
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { querySeleniumJourneyBasePageList, removeSeleniumJourneyBaseById } from '@/api/xyj'
export default {
  name: 'XyjBases',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      querySeleniumJourneyBasePageList({ baseName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 跳转基地商品页面
    goodsToBtn (infoId) {
      this.$router.push({path: '/bases_goods_list', query: {dataId: infoId}})
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/xyj_bases_add', query: {dataId: infoId}})
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeSeleniumJourneyBaseById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xyj/Bases.vue